export default function isPlayable(guideItem) {
  const { canPlay, guideId, subscriptionRequired } =
    guideItem?.actions?.play || {};
  return !!(canPlay && guideId && !subscriptionRequired);
}
